export const convertToCurrency = (value) => {
    if(!value){
        let zero = 0
        return zero.toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 2 })
    }
    return value.toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 2 })
}